// src/permissions.ts
var PERMISSIONS = {
  // Store Management
  STORES_VIEW: "stores:view",
  STORES_CREATE: "stores:create",
  STORES_UPDATE: "stores:update",
  STORES_DELETE: "stores:delete",
  // User Management
  USERS_VIEW: "users:view",
  USERS_CREATE: "users:create",
  USERS_UPDATE: "users:update",
  USERS_DELETE: "users:delete",
  // Customer Management
  CUSTOMERS_VIEW: "customers:view",
  CUSTOMERS_CREATE: "customers:create",
  CUSTOMERS_UPDATE: "customers:update",
  CUSTOMERS_DELETE: "customers:delete",
  // Duyệt xác minh 18+ (xem giấy tờ, approve/reject)
  CUSTOMERS_AGE_VERIFY: "customers:age:verify",
  // Category Management
  CATEGORIES_VIEW: "categories:view",
  CATEGORIES_CREATE: "categories:create",
  CATEGORIES_UPDATE: "categories:update",
  CATEGORIES_DELETE: "categories:delete",
  // Product Management
  PRODUCTS_VIEW: "products:view",
  PRODUCTS_CREATE: "products:create",
  PRODUCTS_UPDATE: "products:update",
  PRODUCTS_DELETE: "products:delete",
  PRODUCTS_PRICE_UPDATE: "products:price:update",
  // Inventory Management
  INVENTORY_VIEW: "inventory:view",
  INVENTORY_ADJUST: "inventory:adjust",
  INVENTORY_COUNT: "inventory:count",
  // Stock Imports
  STOCK_IMPORTS_VIEW: "stock-imports:view",
  STOCK_IMPORTS_CREATE: "stock-imports:create",
  STOCK_IMPORTS_UPDATE: "stock-imports:update",
  STOCK_IMPORTS_SUBMIT: "stock-imports:submit",
  STOCK_IMPORTS_APPROVE: "stock-imports:approve",
  STOCK_IMPORTS_REJECT: "stock-imports:reject",
  STOCK_IMPORTS_RECEIVE: "stock-imports:receive",
  // Orders
  ORDERS_VIEW: "orders:view",
  ORDERS_CREATE: "orders:create",
  ORDERS_UPDATE: "orders:update",
  ORDERS_CANCEL: "orders:cancel",
  ORDERS_REFUND: "orders:refund",
  // Payments
  PAYMENTS_VIEW: "payments:view",
  PAYMENTS_PROCESS: "payments:process",
  PAYMENTS_REFUND: "payments:refund",
  // Promotions
  PROMOTIONS_VIEW: "promotions:view",
  PROMOTIONS_CREATE: "promotions:create",
  PROMOTIONS_UPDATE: "promotions:update",
  PROMOTIONS_DELETE: "promotions:delete",
  PROMOTIONS_ACTIVATE: "promotions:activate",
  // Loyalty
  LOYALTY_VIEW: "loyalty:view",
  LOYALTY_ADJUST: "loyalty:adjust",
  // Access Control
  ACCESS_VIEW: "access:view",
  ACCESS_GENERATE: "access:generate",
  // Nedap AtWork (door access control)
  ATWORK_VIEW: "atwork:view",
  ATWORK_OPEN: "atwork:open",
  // Reports
  REPORTS_SALES: "reports:sales",
  REPORTS_INVENTORY: "reports:inventory",
  REPORTS_ORDERS: "reports:orders",
  REPORTS_CUSTOMERS: "reports:customers",
  REPORTS_EXPORT: "reports:export",
  // Settings
  SETTINGS_VIEW: "settings:view",
  SETTINGS_UPDATE: "settings:update"
};
var ROLE_PERMISSIONS = {
  AI_ADMIN: Object.values(PERMISSIONS),
  // Full access
  STORE_ADMIN: [
    // Store - view only (can't create/delete)
    PERMISSIONS.STORES_VIEW,
    PERMISSIONS.STORES_UPDATE,
    // Users - view and manage operators
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.USERS_CREATE,
    PERMISSIONS.USERS_UPDATE,
    // Full customer management
    PERMISSIONS.CUSTOMERS_VIEW,
    PERMISSIONS.CUSTOMERS_CREATE,
    PERMISSIONS.CUSTOMERS_UPDATE,
    // Duyệt xác minh 18+ tại cửa hàng (chốt 06/08/2026: STORE_ADMIN + AI_ADMIN)
    PERMISSIONS.CUSTOMERS_AGE_VERIFY,
    // Full category management
    PERMISSIONS.CATEGORIES_VIEW,
    PERMISSIONS.CATEGORIES_CREATE,
    PERMISSIONS.CATEGORIES_UPDATE,
    // Full product management
    PERMISSIONS.PRODUCTS_VIEW,
    PERMISSIONS.PRODUCTS_CREATE,
    PERMISSIONS.PRODUCTS_UPDATE,
    PERMISSIONS.PRODUCTS_PRICE_UPDATE,
    // Full inventory management
    PERMISSIONS.INVENTORY_VIEW,
    PERMISSIONS.INVENTORY_ADJUST,
    PERMISSIONS.INVENTORY_COUNT,
    // Stock imports (create, update, submit - but not approve)
    PERMISSIONS.STOCK_IMPORTS_VIEW,
    PERMISSIONS.STOCK_IMPORTS_CREATE,
    PERMISSIONS.STOCK_IMPORTS_UPDATE,
    PERMISSIONS.STOCK_IMPORTS_SUBMIT,
    PERMISSIONS.STOCK_IMPORTS_RECEIVE,
    // Full order management
    PERMISSIONS.ORDERS_VIEW,
    PERMISSIONS.ORDERS_CREATE,
    PERMISSIONS.ORDERS_UPDATE,
    PERMISSIONS.ORDERS_CANCEL,
    PERMISSIONS.ORDERS_REFUND,
    // Payment management
    PERMISSIONS.PAYMENTS_VIEW,
    PERMISSIONS.PAYMENTS_PROCESS,
    PERMISSIONS.PAYMENTS_REFUND,
    // Full promotion management
    PERMISSIONS.PROMOTIONS_VIEW,
    PERMISSIONS.PROMOTIONS_CREATE,
    PERMISSIONS.PROMOTIONS_UPDATE,
    PERMISSIONS.PROMOTIONS_ACTIVATE,
    // Loyalty view and adjust
    PERMISSIONS.LOYALTY_VIEW,
    PERMISSIONS.LOYALTY_ADJUST,
    // Access control view
    PERMISSIONS.ACCESS_VIEW,
    // Nedap AtWork: xem thống kê/event + mở cửa trong store scope
    PERMISSIONS.ATWORK_VIEW,
    PERMISSIONS.ATWORK_OPEN,
    // All reports
    PERMISSIONS.REPORTS_SALES,
    PERMISSIONS.REPORTS_INVENTORY,
    PERMISSIONS.REPORTS_ORDERS,
    PERMISSIONS.REPORTS_CUSTOMERS,
    PERMISSIONS.REPORTS_EXPORT,
    // Settings view
    PERMISSIONS.SETTINGS_VIEW
  ],
  OPERATOR: [
    // Read-only for store info
    PERMISSIONS.STORES_VIEW,
    // Customer view and create
    PERMISSIONS.CUSTOMERS_VIEW,
    PERMISSIONS.CUSTOMERS_CREATE,
    // View categories and products
    PERMISSIONS.CATEGORIES_VIEW,
    PERMISSIONS.PRODUCTS_VIEW,
    // Inventory view, count and adjust.
    // INVENTORY_ADJUST: BE xác nhận 29/08/2026 — POST /inventory/adjust/ gác
    // IsOperator (OPERATOR/STORE_ADMIN/AI_ADMIN đều qua). Trước đây FE thiếu
    // quyền này cho OPERATOR trong khi API_REFERENCE vẫn ghi có — FE sai.
    PERMISSIONS.INVENTORY_VIEW,
    PERMISSIONS.INVENTORY_COUNT,
    PERMISSIONS.INVENTORY_ADJUST,
    // Stock imports view and receive
    PERMISSIONS.STOCK_IMPORTS_VIEW,
    PERMISSIONS.STOCK_IMPORTS_RECEIVE,
    // Order operations
    PERMISSIONS.ORDERS_VIEW,
    PERMISSIONS.ORDERS_CREATE,
    PERMISSIONS.ORDERS_CANCEL,
    // Payment processing
    PERMISSIONS.PAYMENTS_VIEW,
    PERMISSIONS.PAYMENTS_PROCESS,
    // View promotions
    PERMISSIONS.PROMOTIONS_VIEW,
    // View loyalty
    PERMISSIONS.LOYALTY_VIEW,
    // Nedap AtWork: xem + mở cửa trong store scope
    PERMISSIONS.ATWORK_VIEW,
    PERMISSIONS.ATWORK_OPEN,
    // Basic reports
    PERMISSIONS.REPORTS_SALES,
    PERMISSIONS.REPORTS_ORDERS
  ],
  CUSTOMER: [
    // View stores
    PERMISSIONS.STORES_VIEW,
    // View products
    PERMISSIONS.CATEGORIES_VIEW,
    PERMISSIONS.PRODUCTS_VIEW,
    // Own orders
    PERMISSIONS.ORDERS_VIEW,
    // Own payments
    PERMISSIONS.PAYMENTS_VIEW,
    // View promotions
    PERMISSIONS.PROMOTIONS_VIEW,
    // Own loyalty
    PERMISSIONS.LOYALTY_VIEW,
    // Generate access (QR)
    PERMISSIONS.ACCESS_GENERATE
  ],
  POS_TERMINAL: [
    // Store info
    PERMISSIONS.STORES_VIEW,
    // Customer lookup
    PERMISSIONS.CUSTOMERS_VIEW,
    PERMISSIONS.CUSTOMERS_CREATE,
    // Products for scanning
    PERMISSIONS.CATEGORIES_VIEW,
    PERMISSIONS.PRODUCTS_VIEW,
    // Order creation
    PERMISSIONS.ORDERS_VIEW,
    PERMISSIONS.ORDERS_CREATE,
    // Payment processing
    PERMISSIONS.PAYMENTS_VIEW,
    PERMISSIONS.PAYMENTS_PROCESS,
    // Coupon validation
    PERMISSIONS.PROMOTIONS_VIEW,
    // Points operations
    PERMISSIONS.LOYALTY_VIEW,
    PERMISSIONS.LOYALTY_ADJUST
  ]
};
function hasPermission(role, permission) {
  return ROLE_PERMISSIONS[role]?.includes(permission) ?? false;
}
function hasAnyPermission(role, permissions) {
  return permissions.some((p) => hasPermission(role, p));
}
function hasAllPermissions(role, permissions) {
  return permissions.every((p) => hasPermission(role, p));
}
function getPermissionsForRole(role) {
  return ROLE_PERMISSIONS[role] ?? [];
}
function canAccessModule(role, module) {
  const modulePermissions = {
    stores: PERMISSIONS.STORES_VIEW,
    users: PERMISSIONS.USERS_VIEW,
    products: PERMISSIONS.PRODUCTS_VIEW,
    inventory: PERMISSIONS.INVENTORY_VIEW,
    orders: PERMISSIONS.ORDERS_VIEW,
    payments: PERMISSIONS.PAYMENTS_VIEW,
    promotions: PERMISSIONS.PROMOTIONS_VIEW,
    reports: PERMISSIONS.REPORTS_SALES
  };
  const permission = modulePermissions[module];
  return permission ? hasPermission(role, permission) : false;
}

// src/routes.ts
var ADMIN_ROUTES = {
  // Auth
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  // Dashboard
  DASHBOARD: "/",
  // Stores
  STORES: "/stores",
  STORES_CREATE: "/stores/create",
  STORES_DETAIL: "/stores/:id",
  STORES_EDIT: "/stores/:id/edit",
  // Users
  USERS: "/users",
  USERS_CREATE: "/users/create",
  USERS_DETAIL: "/users/:id",
  USERS_EDIT: "/users/:id/edit",
  // Customers
  CUSTOMERS: "/customers",
  CUSTOMERS_DETAIL: "/customers/:id",
  AGE_VERIFICATIONS: "/age-verifications",
  /** Sổ bằng chứng bán hàng 18+ — để trình khi bị thanh tra. */
  RESTRICTED_SALES: "/restricted-sales",
  /**
   * Góp ý của khách (bug #208) — xếp cùng nhóm "Khách hàng" như ở Sidebar, vì
   * đây cũng là việc đọc và trả lời một luồng do khách khởi xướng.
   *
   * KHÔNG có `FEEDBACK_DETAIL`: màn này mở chi tiết bằng modal ngay trên danh
   * sách, không có URL riêng theo id. Chỉ thêm hằng đó khi thực sự đăng ký một
   * route `/feedback/:id` trong `AppRouter`.
   */
  FEEDBACK: "/feedback",
  /**
   * Hàng chờ khiếu nại hoá đơn sau bán (sheet 2 mục #58/#60).
   * Cùng nhóm "việc do khách khởi xướng" với FEEDBACK. Khác góp ý ở chỗ:
   * chốt ở đây là HOÀN TIỀN THẬT, nên chỉ STORE_ADMIN/AI_ADMIN được vào.
   * Chi tiết mở bằng modal trên danh sách — không có route theo id.
   */
  DISPUTES: "/disputes",
  /**
   * Xử lý đổi/trả tại quầy (sheet 2 mục #55/#56/#59).
   * Quyền TÁCH 2 TẦNG (BE 03/09/2026), và tầng thứ hai nằm TRONG trang chứ
   * không ở route: quét/xem/nhận hàng cho OPERATOR trở lên, còn duyệt/từ
   * chối/hoàn tiền chỉ STORE_ADMIN & AI_ADMIN.
   * Route vì thế mở cho cả OPERATOR — siết route lên STORE_ADMIN là bắt quản
   * lý có mặt mỗi lần khách mang hàng đến quầy, sai vận hành.
   * PERMISSIONS chưa có mã nào cho returns nên gác bằng ROLE, cùng quy ước
   * với FEEDBACK/DISPUTES.
   */
  RETURNS: "/returns",
  // Categories
  CATEGORIES: "/categories",
  CATEGORIES_CREATE: "/categories/create",
  CATEGORIES_EDIT: "/categories/:id/edit",
  // Products
  PRODUCTS: "/products",
  PRODUCTS_CREATE: "/products/create",
  PRODUCTS_DETAIL: "/products/:id",
  PRODUCTS_EDIT: "/products/:id/edit",
  // Inventory
  INVENTORY: "/inventory",
  INVENTORY_ADJUSTMENTS: "/inventory/adjustments",
  INVENTORY_DRIFT: "/inventory/drift",
  INVENTORY_BATCHES: "/inventory/batches",
  INVENTORY_STOCKTAKES: "/inventory/stocktakes",
  INVENTORY_LOW_STOCK: "/inventory/low-stock",
  /** Thống kê hao hụt theo nguyên nhân — mục #220. */
  INVENTORY_LOSS_STATS: "/inventory/loss-stats",
  // Stock Imports
  STOCK_IMPORTS: "/stock-imports",
  STOCK_IMPORTS_CREATE: "/stock-imports/create",
  STOCK_IMPORTS_DETAIL: "/stock-imports/:id",
  STOCK_IMPORTS_EDIT: "/stock-imports/:id/edit",
  // Suppliers
  SUPPLIERS: "/suppliers",
  SUPPLIERS_CREATE: "/suppliers/create",
  SUPPLIERS_DETAIL: "/suppliers/:id",
  SUPPLIERS_EDIT: "/suppliers/:id/edit",
  // Orders
  ORDERS: "/orders",
  ORDERS_DETAIL: "/orders/:id",
  // Payments
  PAYMENTS: "/payments",
  PAYMENTS_DETAIL: "/payments/:id",
  // Loyalty
  LOYALTY: "/loyalty",
  LOYALTY_ACCOUNTS: "/loyalty/accounts",
  LOYALTY_ACCOUNT_DETAIL: "/loyalty/accounts/:id",
  LOYALTY_ENTRIES: "/loyalty/entries",
  // Roles
  ROLES: "/roles",
  // Access Control
  ACCESS_CONTROL: "/access-control",
  ACCESS_TOKENS: "/access-control/tokens",
  ACCESS_EVENTS: "/access-control/events",
  SHOPPING_SESSIONS: "/access-control/sessions",
  SHOPPING_SESSION_DETAIL: "/access-control/sessions/:id",
  // Nedap AtWork (door access control)
  ATWORK: "/atwork",
  ATWORK_DOOR_DETAIL: "/atwork/doors/:doorId",
  // Promotions
  PROMOTIONS: "/promotions",
  PROMOTIONS_CREATE: "/promotions/create",
  PROMOTIONS_DETAIL: "/promotions/:id",
  PROMOTIONS_EDIT: "/promotions/:id/edit",
  // Reports
  REPORTS: "/reports",
  REPORTS_SALES: "/reports/sales",
  REPORTS_INVENTORY: "/reports/inventory",
  REPORTS_ORDERS: "/reports/orders",
  REPORTS_CUSTOMERS: "/reports/customers",
  REPORTS_LOYALTY: "/reports/loyalty",
  /** Chốt cuối ngày theo cửa hàng + ngày (sheet 2 mục #53). */
  REPORTS_DAILY_CLOSE: "/reports/daily-close",
  // Audit Logs
  AUDIT_LOGS: "/audit-logs",
  // Shipping
  SHIPPING: "/shipping",
  // Order Proposals
  ORDER_PROPOSALS: "/order-proposals",
  // Settings
  SETTINGS: "/settings",
  SETTINGS_PROFILE: "/settings/profile",
  SETTINGS_STORE: "/settings/store"
};
var POS_ROUTES = {
  // Auth
  LOGIN: "/login",
  DEVICE_SETUP: "/device-setup",
  // Main
  HOME: "/",
  // Checkout
  CHECKOUT: "/checkout",
  CHECKOUT_PAYMENT: "/checkout/payment",
  CHECKOUT_COMPLETE: "/checkout/complete",
  // Product
  PRODUCTS: "/products",
  PRODUCT_DETAIL: "/products/:id",
  // Customer
  CUSTOMER_LOOKUP: "/customer",
  // Orders
  ORDERS: "/orders",
  ORDER_DETAIL: "/orders/:id",
  // Settings
  SETTINGS: "/settings",
  // Admin (for store admin access on POS)
  ADMIN: "/admin",
  ADMIN_INVENTORY: "/admin/inventory",
  ADMIN_REPORTS: "/admin/reports"
};
var USER_ROUTES = {
  // Auth Stack
  AUTH: {
    LOGIN: "Login",
    OTP_VERIFY: "OTPVerify",
    REGISTER: "Register"
  },
  // Main Tab Navigator
  MAIN: {
    HOME: "Home",
    STORES: "Stores",
    ORDERS: "Orders",
    LOYALTY: "Loyalty",
    PROFILE: "Profile"
  },
  // Store Stack
  STORE: {
    LIST: "StoreList",
    DETAIL: "StoreDetail",
    QR_ENTRY: "QREntry",
    PRODUCTS: "StoreProducts"
  },
  // Order Stack
  ORDER: {
    LIST: "OrderList",
    DETAIL: "OrderDetail",
    RECEIPT: "Receipt"
  },
  // Loyalty Stack
  LOYALTY: {
    DASHBOARD: "LoyaltyDashboard",
    HISTORY: "PointsHistory",
    REWARDS: "Rewards"
  },
  // Profile Stack
  PROFILE: {
    VIEW: "ProfileView",
    EDIT: "ProfileEdit",
    SETTINGS: "Settings",
    NOTIFICATIONS: "Notifications",
    HELP: "Help"
  }
};
function buildPath(route, params) {
  let path = route;
  for (const [key, value] of Object.entries(params)) {
    path = path.replace(`:${key}`, String(value));
  }
  return path;
}
function buildPathWithQuery(route, query) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== void 0) {
      params.append(key, String(value));
    }
  }
  const queryString = params.toString();
  return queryString ? `${route}?${queryString}` : route;
}
function matchPath(currentPath, routePattern) {
  const pattern = routePattern.replace(/:[\w]+/g, "[^/]+");
  const regex = new RegExp(`^${pattern}$`);
  return regex.test(currentPath);
}
function extractParams(currentPath, routePattern) {
  const patternParts = routePattern.split("/");
  const pathParts = currentPath.split("/");
  const params = {};
  patternParts.forEach((part, index) => {
    if (part.startsWith(":")) {
      const paramName = part.slice(1);
      params[paramName] = pathParts[index];
    }
  });
  return params;
}

// src/status.ts
var STORE_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  CLOSED: "CLOSED"
};
var STORE_STATUS_OPTIONS = [
  { value: STORE_STATUS.ACTIVE, label: "Ho\u1EA1t \u0111\u1ED9ng", color: "green" },
  { value: STORE_STATUS.INACTIVE, label: "T\u1EA1m ng\u01B0ng", color: "yellow" },
  { value: STORE_STATUS.CLOSED, label: "\u0110\xE3 \u0111\xF3ng", color: "red" }
];
var PRODUCT_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
};
var PRODUCT_STATUS_OPTIONS = [
  { value: PRODUCT_STATUS.ACTIVE, label: "\u0110ang b\xE1n", color: "green" },
  { value: PRODUCT_STATUS.INACTIVE, label: "Ng\u01B0ng b\xE1n", color: "red" }
];
var INVENTORY_STATUS = {
  IN_STOCK: "IN_STOCK",
  LOW_STOCK: "LOW_STOCK",
  OUT_OF_STOCK: "OUT_OF_STOCK"
};
var INVENTORY_STATUS_OPTIONS = [
  { value: INVENTORY_STATUS.IN_STOCK, label: "C\xF2n h\xE0ng", color: "green" },
  { value: INVENTORY_STATUS.LOW_STOCK, label: "S\u1EAFp h\u1EBFt", color: "yellow" },
  { value: INVENTORY_STATUS.OUT_OF_STOCK, label: "H\u1EBFt h\xE0ng", color: "red" }
];
var ADJUSTMENT_TYPE = {
  INCREASE: "INCREASE",
  DECREASE: "DECREASE",
  SET_ABSOLUTE: "SET_ABSOLUTE",
  DAMAGE: "DAMAGE",
  MANUAL_CORRECTION: "MANUAL_CORRECTION",
  RETURN: "RETURN",
  RESTOCK: "RESTOCK"
};
var ADJUSTMENT_TYPE_OPTIONS = [
  { value: ADJUSTMENT_TYPE.SET_ABSOLUTE, labelKey: "adjustTypeSetAbsolute", label: "Ki\u1EC3m \u0111\u1EBFm", color: "purple" },
  { value: ADJUSTMENT_TYPE.INCREASE, labelKey: "adjustTypeIncrease", label: "T\u0103ng t\u1ED3n", color: "green" },
  { value: ADJUSTMENT_TYPE.DECREASE, labelKey: "adjustTypeDecrease", label: "Gi\u1EA3m t\u1ED3n", color: "orange" },
  { value: ADJUSTMENT_TYPE.DAMAGE, labelKey: "adjustTypeDamage", label: "H\xE0ng h\u1ECFng", color: "red" },
  { value: ADJUSTMENT_TYPE.RESTOCK, labelKey: "adjustTypeRestock", label: "Nh\u1EADp b\u1ED5 sung", color: "green" },
  { value: ADJUSTMENT_TYPE.RETURN, labelKey: "adjustTypeReturn", label: "Tr\u1EA3 h\xE0ng", color: "orange" },
  // Chỉ CỘNG THÊM, không giảm được — giữ ở bộ lọc lịch sử để đọc được bản ghi
  // cũ, nhưng KHÔNG cho chọn tay khi tạo điều chỉnh (dùng SET_ABSOLUTE).
  { value: ADJUSTMENT_TYPE.MANUAL_CORRECTION, labelKey: "adjustTypeManualCorrection", label: "\u0110i\u1EC1u ch\u1EC9nh tay", color: "blue" }
];
var STOCK_IMPORT_STATUS = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  RECEIVING: "RECEIVING",
  COMPLETED: "COMPLETED"
};
var STOCK_IMPORT_STATUS_OPTIONS = [
  { value: STOCK_IMPORT_STATUS.DRAFT, labelKey: "stockImportStatusDraft", label: "Nh\xE1p", color: "gray" },
  { value: STOCK_IMPORT_STATUS.SUBMITTED, labelKey: "stockImportStatusSubmitted", label: "Ch\u1EDD duy\u1EC7t", color: "yellow" },
  { value: STOCK_IMPORT_STATUS.APPROVED, labelKey: "stockImportStatusApproved", label: "\u0110\xE3 duy\u1EC7t", color: "blue" },
  { value: STOCK_IMPORT_STATUS.REJECTED, labelKey: "stockImportStatusRejected", label: "T\u1EEB ch\u1ED1i", color: "red" },
  { value: STOCK_IMPORT_STATUS.RECEIVING, labelKey: "stockImportStatusReceiving", label: "\u0110ang nh\u1EADp", color: "orange" },
  { value: STOCK_IMPORT_STATUS.COMPLETED, labelKey: "stockImportStatusCompleted", label: "Ho\xE0n th\xE0nh", color: "green" }
];
var ORDER_STATUS = {
  DRAFT: "DRAFT",
  PENDING_PAYMENT: "PENDING_PAYMENT",
  PAID: "PAID",
  CONFIRMED: "CONFIRMED",
  PREPARING: "PREPARING",
  READY: "READY",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  VOIDED: "VOIDED",
  REFUNDED: "REFUNDED",
  PARTIALLY_REFUNDED: "PARTIALLY_REFUNDED"
};
var ORDER_STATUS_OPTIONS = [
  { value: ORDER_STATUS.DRAFT, label: "Nh\xE1p", color: "gray" },
  { value: ORDER_STATUS.PENDING_PAYMENT, label: "Ch\u1EDD thanh to\xE1n", color: "yellow" },
  { value: ORDER_STATUS.PAID, label: "\u0110\xE3 thanh to\xE1n", color: "green" },
  { value: ORDER_STATUS.CONFIRMED, label: "\u0110\xE3 x\xE1c nh\u1EADn", color: "blue" },
  { value: ORDER_STATUS.PREPARING, label: "\u0110ang chu\u1EA9n b\u1ECB", color: "orange" },
  { value: ORDER_STATUS.READY, label: "S\u1EB5n s\xE0ng", color: "purple" },
  { value: ORDER_STATUS.COMPLETED, label: "Ho\xE0n th\xE0nh", color: "green" },
  { value: ORDER_STATUS.CANCELLED, label: "\u0110\xE3 h\u1EE7y", color: "red" },
  { value: ORDER_STATUS.VOIDED, label: "\u0110\xE3 h\u1EE7y giao d\u1ECBch", color: "gray" },
  { value: ORDER_STATUS.REFUNDED, label: "\u0110\xE3 ho\xE0n ti\u1EC1n", color: "orange" },
  { value: ORDER_STATUS.PARTIALLY_REFUNDED, label: "Ho\xE0n ti\u1EC1n m\u1ED9t ph\u1EA7n", color: "orange" }
];
var ORDER_CHANNEL = {
  POS: "POS",
  MOBILE: "MOBILE",
  KIOSK: "KIOSK",
  WEB: "WEB"
};
var ORDER_CHANNEL_OPTIONS = [
  { value: ORDER_CHANNEL.POS, label: "POS", color: "blue" },
  { value: ORDER_CHANNEL.MOBILE, label: "Mobile App", color: "green" },
  { value: ORDER_CHANNEL.KIOSK, label: "Kiosk", color: "purple" },
  { value: ORDER_CHANNEL.WEB, label: "Website", color: "orange" }
];
var PAYMENT_STATUS = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  REFUNDED: "REFUNDED",
  CANCELLED: "CANCELLED"
};
var PAYMENT_STATUS_OPTIONS = [
  { value: PAYMENT_STATUS.PENDING, label: "Ch\u1EDD thanh to\xE1n", color: "yellow" },
  { value: PAYMENT_STATUS.PROCESSING, label: "\u0110ang x\u1EED l\xFD", color: "blue" },
  { value: PAYMENT_STATUS.COMPLETED, label: "Th\xE0nh c\xF4ng", color: "green" },
  { value: PAYMENT_STATUS.FAILED, label: "Th\u1EA5t b\u1EA1i", color: "red" },
  { value: PAYMENT_STATUS.REFUNDED, label: "\u0110\xE3 ho\xE0n ti\u1EC1n", color: "orange" },
  { value: PAYMENT_STATUS.CANCELLED, label: "\u0110\xE3 h\u1EE7y", color: "gray" }
];
var PAYMENT_METHOD = {
  CASH: "cash",
  CARD: "card",
  MOMO: "momo",
  VNPAY: "vnpay",
  ZALOPAY: "zalopay",
  BANK_TRANSFER: "bank_transfer"
};
var PAYMENT_METHOD_OPTIONS = [
  { value: PAYMENT_METHOD.CASH, label: "Ti\u1EC1n m\u1EB7t", icon: "cash" },
  { value: PAYMENT_METHOD.CARD, label: "Th\u1EBB", icon: "card" },
  { value: PAYMENT_METHOD.MOMO, label: "MoMo", icon: "momo" },
  { value: PAYMENT_METHOD.VNPAY, label: "VNPay", icon: "vnpay" },
  { value: PAYMENT_METHOD.ZALOPAY, label: "ZaloPay", icon: "zalopay" },
  { value: PAYMENT_METHOD.BANK_TRANSFER, label: "Chuy\u1EC3n kho\u1EA3n", icon: "bank" }
];
var PROMOTION_STATUS = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED"
};
var PROMOTION_STATUS_OPTIONS = [
  { value: PROMOTION_STATUS.DRAFT, label: "Nh\xE1p", color: "gray" },
  { value: PROMOTION_STATUS.ACTIVE, label: "\u0110ang ch\u1EA1y", color: "green" },
  { value: PROMOTION_STATUS.PAUSED, label: "T\u1EA1m d\u1EEBng", color: "yellow" },
  { value: PROMOTION_STATUS.EXPIRED, label: "H\u1EBFt h\u1EA1n", color: "red" },
  { value: PROMOTION_STATUS.CANCELLED, label: "\u0110\xE3 h\u1EE7y", color: "gray" }
];
var PROMOTION_TYPE = {
  COUPON: "COUPON",
  AUTOMATIC: "AUTOMATIC",
  FLASH_SALE: "FLASH_SALE",
  LOYALTY: "LOYALTY"
};
var PROMOTION_TYPE_OPTIONS = [
  { value: PROMOTION_TYPE.COUPON, label: "M\xE3 gi\u1EA3m gi\xE1", icon: "tag" },
  { value: PROMOTION_TYPE.AUTOMATIC, label: "T\u1EF1 \u0111\u1ED9ng", icon: "auto" },
  { value: PROMOTION_TYPE.FLASH_SALE, label: "Flash Sale", icon: "flash" },
  { value: PROMOTION_TYPE.LOYALTY, label: "Th\xE0nh vi\xEAn", icon: "star" }
];
var LOYALTY_TIER = {
  BRONZE: "BRONZE",
  SILVER: "SILVER",
  GOLD: "GOLD",
  PLATINUM: "PLATINUM"
};
var LOYALTY_TIER_OPTIONS = [
  { value: LOYALTY_TIER.BRONZE, label: "\u0110\u1ED3ng", color: "orange" },
  { value: LOYALTY_TIER.SILVER, label: "B\u1EA1c", color: "gray" },
  { value: LOYALTY_TIER.GOLD, label: "V\xE0ng", color: "yellow" },
  { value: LOYALTY_TIER.PLATINUM, label: "B\u1EA1ch kim", color: "purple" }
];
var LOYALTY_ENTRY_TYPE = {
  EARN: "EARN",
  REDEEM: "REDEEM",
  ADJUST: "ADJUST",
  EXPIRE: "EXPIRE",
  BONUS: "BONUS"
};
var LOYALTY_ENTRY_TYPE_OPTIONS = [
  { value: LOYALTY_ENTRY_TYPE.EARN, label: "T\xEDch \u0111i\u1EC3m", color: "green" },
  { value: LOYALTY_ENTRY_TYPE.REDEEM, label: "\u0110\u1ED5i \u0111i\u1EC3m", color: "blue" },
  { value: LOYALTY_ENTRY_TYPE.ADJUST, label: "\u0110i\u1EC1u ch\u1EC9nh", color: "purple" },
  { value: LOYALTY_ENTRY_TYPE.EXPIRE, label: "H\u1EBFt h\u1EA1n", color: "red" },
  { value: LOYALTY_ENTRY_TYPE.BONUS, label: "Th\u01B0\u1EDFng", color: "yellow" }
];
var ACCESS_METHOD = {
  QR_CODE: "QR_CODE",
  NFC: "NFC",
  FACE_RECOGNITION: "FACE_RECOGNITION",
  MANUAL: "MANUAL"
};
var ACCESS_METHOD_OPTIONS = [
  { value: ACCESS_METHOD.QR_CODE, label: "M\xE3 QR", icon: "qr" },
  { value: ACCESS_METHOD.NFC, label: "NFC", icon: "nfc" },
  { value: ACCESS_METHOD.FACE_RECOGNITION, label: "Nh\u1EADn di\u1EC7n khu\xF4n m\u1EB7t", icon: "face" },
  { value: ACCESS_METHOD.MANUAL, label: "Th\u1EE7 c\xF4ng", icon: "hand" }
];
var ACCESS_RESULT = {
  SUCCESS: "SUCCESS",
  DENIED: "DENIED",
  EXPIRED: "EXPIRED",
  INVALID: "INVALID"
};
var ACCESS_RESULT_OPTIONS = [
  { value: ACCESS_RESULT.SUCCESS, label: "Th\xE0nh c\xF4ng", color: "green" },
  { value: ACCESS_RESULT.DENIED, label: "T\u1EEB ch\u1ED1i", color: "red" },
  { value: ACCESS_RESULT.EXPIRED, label: "H\u1EBFt h\u1EA1n", color: "orange" },
  { value: ACCESS_RESULT.INVALID, label: "Kh\xF4ng h\u1EE3p l\u1EC7", color: "red" }
];
var USER_ROLE = {
  AI_ADMIN: "AI_ADMIN",
  STORE_ADMIN: "STORE_ADMIN",
  OPERATOR: "OPERATOR",
  CUSTOMER: "CUSTOMER",
  POS_TERMINAL: "POS_TERMINAL"
};
var USER_ROLE_OPTIONS = [
  { value: USER_ROLE.AI_ADMIN, label: "Qu\u1EA3n tr\u1ECB vi\xEAn h\u1EC7 th\u1ED1ng", level: 1 },
  { value: USER_ROLE.STORE_ADMIN, label: "Qu\u1EA3n l\xFD c\u1EEDa h\xE0ng", level: 2 },
  { value: USER_ROLE.OPERATOR, label: "Nh\xE2n vi\xEAn", level: 3 },
  { value: USER_ROLE.CUSTOMER, label: "Kh\xE1ch h\xE0ng", level: 4 },
  { value: USER_ROLE.POS_TERMINAL, label: "Thi\u1EBFt b\u1ECB POS", level: 5 }
];
var GENDER = {
  MALE: "MALE",
  FEMALE: "FEMALE",
  OTHER: "OTHER"
};
var GENDER_OPTIONS = [
  { value: GENDER.MALE, label: "Nam" },
  { value: GENDER.FEMALE, label: "N\u1EEF" },
  { value: GENDER.OTHER, label: "Kh\xE1c" }
];
var ATWORK_COMMAND_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
};
var ATWORK_COMMAND_STATUS_OPTIONS = [
  { value: ATWORK_COMMAND_STATUS.PENDING, label: "Processing", color: "orange" },
  { value: ATWORK_COMMAND_STATUS.SUCCESS, label: "Success", color: "green" },
  { value: ATWORK_COMMAND_STATUS.FAILED, label: "Failed", color: "red" }
];
var ATWORK_COMMAND_SOURCE = {
  ADMIN_WEB: "ADMIN_WEB",
  MOBILE_APP: "MOBILE_APP",
  AI: "AI",
  SYSTEM: "SYSTEM"
};
var ATWORK_COMMAND_SOURCE_OPTIONS = [
  { value: ATWORK_COMMAND_SOURCE.ADMIN_WEB, label: "Admin Web" },
  { value: ATWORK_COMMAND_SOURCE.MOBILE_APP, label: "Mobile App" },
  { value: ATWORK_COMMAND_SOURCE.AI, label: "AI" },
  { value: ATWORK_COMMAND_SOURCE.SYSTEM, label: "System" }
];
var ATWORK_ERROR_MESSAGES = {
  NEDAP_INVALID_DOOR_ID: "M\xE3 c\u1EEDa kh\xF4ng h\u1EE3p l\u1EC7.",
  NEDAP_AUTHORIZATION_DENIED: "H\u1EC7 th\u1ED1ng kh\xF4ng c\xF3 quy\u1EC1n m\u1EDF c\u1EEDa n\xE0y.",
  NEDAP_DOOR_NOT_EXISTS: "C\u1EEDa kh\xF4ng t\u1ED3n t\u1EA1i ho\u1EB7c ch\u01B0a \u0111\u01B0\u1EE3c \u0111\u1ED3ng b\u1ED9.",
  NEDAP_PROVIDE_ACCESS_DISABLED: "C\u1EEDa ch\u01B0a b\u1EADt t\xEDnh n\u0103ng m\u1EDF c\u1EEDa t\u1EEB xa.",
  NEDAP_RETURNED_FALSE: "H\u1EC7 th\u1ED1ng c\u1EEDa t\u1EEB ch\u1ED1i l\u1EC7nh m\u1EDF.",
  NEDAP_PROVIDE_ACCESS_FAILED: "G\u1EEDi l\u1EC7nh m\u1EDF c\u1EEDa th\u1EA5t b\u1EA1i. Vui l\xF2ng th\u1EED l\u1EA1i."
};
var ATWORK_EVENT_TYPES_OPENED = [
  "ACCESS_GRANTED",
  "DOOR_OPENED",
  "DOOR_UNLOCKED",
  "DOOR_PROVIDE_ACCESS",
  "DOOR_MANUAL_UNLOCK",
  "DOOR_AUTOMATIC_UNLOCK"
];
var ATWORK_EVENT_TYPES_ENDED = [
  "DOOR_OPENED_ENDED",
  "DOOR_UNLOCKED_ENDED",
  "DOOR_MANUAL_UNLOCK_ENDED"
];
export {
  ACCESS_METHOD,
  ACCESS_METHOD_OPTIONS,
  ACCESS_RESULT,
  ACCESS_RESULT_OPTIONS,
  ADJUSTMENT_TYPE,
  ADJUSTMENT_TYPE_OPTIONS,
  ADMIN_ROUTES,
  ATWORK_COMMAND_SOURCE,
  ATWORK_COMMAND_SOURCE_OPTIONS,
  ATWORK_COMMAND_STATUS,
  ATWORK_COMMAND_STATUS_OPTIONS,
  ATWORK_ERROR_MESSAGES,
  ATWORK_EVENT_TYPES_ENDED,
  ATWORK_EVENT_TYPES_OPENED,
  GENDER,
  GENDER_OPTIONS,
  INVENTORY_STATUS,
  INVENTORY_STATUS_OPTIONS,
  LOYALTY_ENTRY_TYPE,
  LOYALTY_ENTRY_TYPE_OPTIONS,
  LOYALTY_TIER,
  LOYALTY_TIER_OPTIONS,
  ORDER_CHANNEL,
  ORDER_CHANNEL_OPTIONS,
  ORDER_STATUS,
  ORDER_STATUS_OPTIONS,
  PAYMENT_METHOD,
  PAYMENT_METHOD_OPTIONS,
  PAYMENT_STATUS,
  PAYMENT_STATUS_OPTIONS,
  PERMISSIONS,
  POS_ROUTES,
  PRODUCT_STATUS,
  PRODUCT_STATUS_OPTIONS,
  PROMOTION_STATUS,
  PROMOTION_STATUS_OPTIONS,
  PROMOTION_TYPE,
  PROMOTION_TYPE_OPTIONS,
  ROLE_PERMISSIONS,
  STOCK_IMPORT_STATUS,
  STOCK_IMPORT_STATUS_OPTIONS,
  STORE_STATUS,
  STORE_STATUS_OPTIONS,
  USER_ROLE,
  USER_ROLE_OPTIONS,
  USER_ROUTES,
  buildPath,
  buildPathWithQuery,
  canAccessModule,
  extractParams,
  getPermissionsForRole,
  hasAllPermissions,
  hasAnyPermission,
  hasPermission,
  matchPath
};
